import React from "react";
import { StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Ionicons } from "@expo/vector-icons";

interface ModalHeaderProps {
  closeModal: () => void;
  handleSave: () => void;
  title: string;
  saveDisabled?: boolean;
}

const ModalHeader: React.FC<ModalHeaderProps> = ({
  closeModal,
  handleSave,
  title,
  saveDisabled = false,
}) => {
  return (
    <View style={styles.modalHeader}>
      <TouchableOpacity onPress={closeModal} style={styles.backButton}>
        <Ionicons name="chevron-back" size={26} color="#007AFF" />
      </TouchableOpacity>
      <Text style={styles.modalTitle}>{title}</Text>
      <TouchableOpacity
        onPress={handleSave}
        style={styles.saveButton}
        disabled={saveDisabled}
      >
        <Text
          style={[
            styles.saveButtonText,
            saveDisabled && styles.saveButtonTextDisabled,
          ]}
        >
          Save
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  backButton: {
    padding: 8,
  },
  modalHeader: {
    alignItems: "center",
    borderBottomColor: "#E0E0E0",
    borderBottomWidth: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    padding: 16,
  },
  modalTitle: {
    flex: 1,
    fontSize: 20,
    fontWeight: "bold",
    textAlign: "center",
  },
  saveButton: {
    padding: 8,
  },
  saveButtonText: {
    color: "#007AFF",
    fontSize: 20,
    fontWeight: "bold",
  },
  saveButtonTextDisabled: {
    opacity: 0.5,
  },
});

export default ModalHeader;
